import _ from 'lodash'
import { Base64 } from 'js-base64'

const getDevelopmentConfig = () => require('./config.development.js') // eslint-disable-line

const getConfigFromWindow = () => {
    const configDecoded = Base64.decode(_.get(window, 'config', ''))
    return _.get(JSON.parse(configDecoded), 'env', {})
}

const config = window && window.config ? getConfigFromWindow() : getDevelopmentConfig()

export default config
